export default function UnitCardMeta(tww_version, key, rank, mount, fatigue) {
    this.v = tww_version;
    this.k = key;
    this.m = mount;
    this.r = rank;
    this.f = fatigue;

    return this;
}